import { useCallback } from 'react';
import { observer } from 'mobx-react-lite';
import { LayoutUser } from '@sagano/share/components';
import { useStore } from '@sagano/train/stores';
import trainAuth from '@sagano/train/vendors/firebase';

const UserView = () => {
  const { auth } = useStore();

  const logout = useCallback(() => {
    trainAuth.logout();
  }, []);

  return <LayoutUser auth={auth} onLogout={logout} />;
};

const User = observer(UserView);

export default User;
